/*!
 * CarOptions Map Picker (COMapPicker)
 * -----------------------------------
 * Description : Custom modal + Google Maps (AdvancedMarkerElement) location picker
 * Filename    : map-picker.js
 * Version     : 1.0.0
 * Build date  : 2025-09-18
 *
 * Author      : CarOptions
 * Contact     : support@caroptions.com
 *
 * License     : MIT
 * SPDX-License-Identifier: MIT
 *
 * Copyright (c) 2025 CarOptions
 *
 * Usage       :
 *   - Load this script after the legacy locationPicker (fallback) but before custom.js
 *   - Toggle via feature flag in custom.js:
 *       window.CO_USE_NEW_MAP = true;  // true = new picker, false = legacy
 *   - Initialization via window.initNewMapPicker() (called from custom.js)
 *
 * Public API  :
 *   - window.COMapPicker.configure({ apiKey, mapId, styles })
 *   - window.COMapPicker.open(locations?)   // open modal (user action only)
 *   - window.COMapPicker.close()            // close modal
 *   - window.initNewMapPicker()             // bootstrap with safety checks
 *
 * Dependencies:
 *   - Google Maps JavaScript API with 'marker' library (lazy loaded if needed)
 *
 * Browser Support:
 *   - Modern evergreen browsers
 *   - iOS Safari 15+ (supports dvh; fallbacks included)
 */(()=>{const q=(s,r=document)=>r.querySelector(s),qa=(s,r=document)=>Array.from(r.querySelectorAll(s)),escapeCSS=val=>window.CSS&&CSS.escape?CSS.escape(val):val.replace(/"/g,'\\"'),isMobile=()=>window.matchMedia("(max-width: 767px)").matches;function wiggle(el){el&&(el.classList.remove("c-loc-card--wiggle"),el.offsetWidth,el.classList.add("c-loc-card--wiggle"),el.addEventListener("animationend",()=>{el.classList.remove("c-loc-card--wiggle")},{once:!0}))}let _scrollLockY=0;function lockBodyScroll(){document.documentElement.classList.contains("c-loc--open")||(_scrollLockY=window.scrollY||window.pageYOffset||0,document.body.style.position="fixed",document.body.style.top=`-${_scrollLockY}px`,document.body.style.left="0",document.body.style.right="0",document.body.style.width="100%",document.body.classList.add("c-loc--open"),document.documentElement.classList.add("c-loc--open"))}function unlockBodyScroll(){document.body.style.position="",document.body.style.top="",document.body.style.left="",document.body.style.right="",document.body.style.width="",document.body.classList.remove("c-loc--open"),document.documentElement.classList.remove("c-loc--open"),window.scrollTo(0,_scrollLockY)}function setScrolled(on){const grid=q(".c-loc__grid",state.modalEl),list=q(".c-loc__list",state.modalEl);!grid||!list||requestAnimationFrame(()=>{grid.classList.toggle("c-loc__scrolled",!!on),list.dataset.scrollEnabled=on?"1":"0",on||(list.scrollTop=0),applyDynamicScrollPosition()})}function setLocationPreview(loc){try{const wrap=document.querySelector(".gpo-form__group.location_selector.options-mk-2--location");if(!wrap||!loc||!loc.img)return;wrap.classList.add("co-loc-selected"),wrap.style.setProperty("--co-loc-img",`url("${loc.img}")`)}catch{}}function applyDynamicScrollPosition(){if(!isMobile()||!state?.modalEl)return;const grid=q(".c-loc__grid",state.modalEl),mapWrap=q(".c-loc__mapwrap",state.modalEl),head=q(".c-loc__sideHead.c-loc__mobile",state.modalEl);if(!grid||!mapWrap||!head)return;const on=grid.classList.contains("c-loc__scrolled"),shift=Math.max(0,head.offsetHeight-97);mapWrap.style.willChange="height, transform, margin-bottom",mapWrap.style.transition="height .5s ease, transform .35s ease, margin-bottom .35s ease",mapWrap.style.transform=on?`translateY(-${shift}px)`:"translateY(0)",mapWrap.style.marginBottom=on?`-${shift}px`:"0px"}const DEFAULT_LOCATIONS=[{key:"exclusive",selectorValue:"Installatie exlusief",title:"CarOptions \u2013 Hoofdvestiging Bleiswijk",subtitle:"Headquarters",address:"Briljantstraat 33 \u2013 2665NJ Bleiswijk",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/map_caroptions.jpg?v=1688424353",lat:52.04251256163202,lng:4.541488494571508,special:!0},{key:"caroptionsBleiswijk",selectorValue:"CarOptions - Bleiswijk",title:"CarOptions Bleiswijk",subtitle:"Headquarters",address:"Briljantstraat 33 \u2013 2665NJ Bleiswijk",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/map_caroptions_bleiswijk.jpg?v=1729421547",lat:52.04251256163202,lng:4.541488494571508},{key:"caroptionsEnkhuizen",selectorValue:"CarOptions - Enkhuizen",title:"CarOptions Enkhuizen",subtitle:"Noord Holland",address:"De Tocht 2a \u2013 1611HT Bovenkarspel",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/map_caroptions_de_goorn.jpg?v=1729904105",lat:52.69289015563048,lng:5.239319644616835},{key:"caroptionsElburg",selectorValue:"CarOptions - Elburg",title:"CarOptions Elburg",subtitle:"Gelderland",address:"Broeklandstraat 8 \u2013 8082AE Elburg",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/caroption_elburg.jpg?v=1730458129",lat:52.442616992849665,lng:5.868252720833886},{key:"caroptionsNijmegen",selectorValue:"CarOptions - Nijmegen",title:"CarOptions Nijmegen",subtitle:"Gelderland",address:"Edisonstraat 26A \u2013 6604BV Wijchen",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/map_caroptions_nijmegen.jpg?v=1756811339",lat:51.817239630587,lng:5.75449604370864},{key:"caroptionsMaastricht",selectorValue:"CarOptions - Maastricht",title:"CarOptions Maastricht",subtitle:"Limburg",address:"Fregatweg 124 \u2013 6222NZ Maastricht",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/caroption_limburg.jpg?v=1730452271",lat:50.874297138348176,lng:5.712468971694348},{key:"caroptionsTilburg",selectorValue:"CarOptions - Tilburg",title:"CarOptions Tilburg",subtitle:"Brabant",address:"Kraaivenstraat 30A \u2013 5048AB Tilburg",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/caroptions_tilburg.jpg?v=1749038263",lat:51.581264882046604,lng:5.065468905951541},{key:"caroptionsHeerenveen",selectorValue:"CarOptions - Heerenveen",title:"CarOptions Heerenveen",subtitle:"Friesland",address:"De Kromten 16 \u2013 8401JJ Gorredijk",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/caroptions_heerenveen.jpg?v=1748858999",lat:53.00708972770668,lng:6.042883895056425},{key:"caroptionsDrachten",selectorValue:"CarOptions - Drachten",title:"CarOptions Drachten",subtitle:"Friesland",address:"De Hemmen 6B \u2013 9206AG Drachten",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/partner_drachten.jpg?v=1771325702",lat:53.110740382157886,lng:6.079220336823333},{key:"caroptionsSusteren",selectorValue:"CarOptions - Susteren",title:"CarOptions Susteren",subtitle:"Limburg",address:"Rafa\xEBlweg 23D \u2013 6114BX Susteren",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/partner_susteren.jpg?v=1771325702",lat:51.07340609317698,lng:5.866111682639487},{key:"caroptionsBergenopZoom",selectorValue:"CarOptions - Bergen op Zoom",title:"CarOptions Bergen op Zoom",subtitle:"Zeeland / Brabant",address:"Industrieweg 1Y \u2013 4661VN Halsteren",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/bergen_op_zoom.jpg?v=1746780442",lat:51.52840381733978,lng:4.280117602978747},{key:"caroptionsAmersfoort",selectorValue:"CarOptions - Amersfoort",title:"CarOptions Amersfoort",subtitle:"Utrecht",address:"Amersfoortseweg 30-22, 3751LK, Bunschoten-Spakenburg",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/partner_amersfoort.jpg?v=1774431475",lat:52.22642286773747,lng:5.369020479655003},{key:"caroptionsDeGoorn",selectorValue:"CarOptions - De Goorn",title:"CarOptions De Goorn",subtitle:"Noord Holland",address:"Schoffel 10a \u2013 1648GG De Goorn",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/de_goorn.jpg?v=1763934855",lat:52.62396813296294,lng:4.9691920000011365},{key:"caroptionsApeldoorn",selectorValue:"CarOptions - Apeldoorn",title:"CarOptions Apeldoorn",subtitle:"Gelderland",address:"Europaweg \u2013 7322AA Apeldoorn",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/partner_locatie_apeldoorn.jpg?v=1735558870",lat:52.17894640460527,lng:5.9688354327123045},{key:"caroptionsWaalwijk",selectorValue:"CarOptions - Waalwijk",title:"CarOptions Waalwijk",subtitle:"Brabant",address:"Cartografenweg 24 \u2013 5141MT Waalwijk",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/map_caroptions_waalwijk.jpg?v=1729421547",lat:51.69261465610327,lng:5.081359879630066},{key:"caroptionsEindhoven",selectorValue:"CarOptions - Eindhoven",title:"CarOptions Eindhoven",subtitle:"Brabant",address:"De Waal 20u - 5684PH Best",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/caroptions_eindhoven.jpg?v=1763938442",lat:51.486295991354226,lng:5.392900515900032},{key:"caroptionsAlkmaar",selectorValue:"CarOptions - Alkmaar",title:"CarOptions Alkmaar",subtitle:"Noord Holland",address:"Rijksweg 50 - 1906BJ Limmen",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/locatie_alkmaar.jpg?v=1772013564",lat:52.56604418411732,lng:4.691602370989654},{key:"caroptionsVenlo",selectorValue:"CarOptions - Venlo",title:"CarOptions Venlo",subtitle:"Noord Limburg",address:"Kalisstraat 30 - 5768CX Meijel",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/venlo_installatie_locatie.jpg?v=1762819245",lat:51.35805172122072,lng:5.874814964890582},{key:"caroptionsTwente",selectorValue:"CarOptions - Twente",title:"CarOptions Twente",subtitle:"Overijssel",address:"Lievelderweg 87 - 7137MB Lievelde",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/venlo_installatie_locatie.jpg?v=1762819245",lat:52.008456297017396,lng:6.5913414356293725},{key:"caroptionsHasselt",selectorValue:"CarOptions - Hasselt",title:"CarOptions Hasselt",subtitle:"Belgi\xEB",address:"Lochtemanweg 96/Bus 3 \u2013 3550 Heusden-Zolder",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/co_partner_hasselt.jpg?v=1759619282",lat:51.031338890087454,lng:5.231993710351828},{key:"caroptionsAntwerpen",selectorValue:"CarOptions - Antwerpen",title:"CarOptions Antwerpen",subtitle:"Belgi\xEB",address:"Brechtsebaan 40/UNIT 62 - 2900 Schoten",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/co_partner_antwerpen.jpg?v=1759619283",lat:51.27797731809533,lng:4.580080607846934},{key:"caroptionsBrugge",selectorValue:"CarOptions - Brugge",title:"CarOptions Brugge",subtitle:"Belgi\xEB",address:"Stationsstraat 187 - 8340 Damme",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/co_partner_brugge.jpg?v=1759619282",lat:51.22191458917305,lng:3.3288720484152043},{key:"haag",selectorValue:"Haaglanden Motorsport",title:"Haaglanden Motorsport B.V.",subtitle:"CarOptions Partner",address:"Gildeweg 10 \u2013 2632BA Nootdorp (Zuid-Holland)",img:"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/map_caroptions_bleiswijk.jpg?v=1729421547",lat:52.037,lng:4.366}],HIDDEN={exclusive:{products:[],variants:[]},caroptionsBleiswijk:{products:[],variants:[]},knippels:{products:[],variants:[]},caroptionsWaalwijk:{products:[],variants:[]},caroptionsApeldoorn:{products:[],variants:[]},caroptionsDeGoorn:{products:[],variants:[]},caroptionsEnkhuizen:{products:[],variants:[]},caroptionsMaastricht:{products:[],variants:[]},caroptionsElburg:{products:[],variants:["44748984484131","44749454311715"]},caroptionsBergenopZoom:{products:[],variants:[]},caroptionsHeerenveen:{products:[],variants:[]},caroptionsTilburg:{products:[],variants:["49720836325710","44748999393571","44748999196963","49696602423630","49696602620238","44748984484131","47990291497294","47990291530062","47196100165966","47196100198734","46744639308110","47196100297038","51042429632846","52757478113614","52757478146382","46710049112398"]},caroptionsNijmegen:{products:[],variants:["49720836325710","44748999393571","44748999196963","49696602423630","49696602620238","44748984484131","47990291497294","47990291530062","47196100165966","47196100198734","46744639308110","47196100297038","51042429632846","52757478113614","52757478146382","46710049112398"]},caroptionsEindhoven:{products:[],variants:["49720836325710","44748999393571","44748999196963","49696602423630","49696602620238","44748984484131","47990291497294","47990291530062","47196100165966","47196100198734","46744639308110","47196100297038","51042429632846","52757478113614","52757478146382","46710049112398"]},caroptionsDrachten:{products:[],variants:["49720836325710","44748999393571","44748999196963","49696602423630","49696602620238","44748984484131","47990291497294","47990291530062","47196100165966","47196100198734","46744639308110","47196100297038","51042429632846","52757478113614","52757478146382","46710049112398"]},caroptionsSusteren:{products:[],variants:["49720836325710","44748999393571","44748999196963","49696602423630","49696602620238","44748984484131","47990291497294","47990291530062","47196100165966","47196100198734","46744639308110","47196100297038","51042429632846","52757478113614","52757478146382","46710049112398"]},caroptionsAlkmaar:{products:[],variants:["49720836325710","44748999393571","44748999196963","49696602423630","49696602620238","44748984484131","47990291497294","47990291530062","47196100165966","47196100198734","46744639308110","47196100297038","51042429632846","52757478113614","52757478146382","46710049112398"]},caroptionsHasselt:{products:[],variants:["44748984484131","44749454311715"]},caroptionsAntwerpen:{products:[],variants:["49720836325710","44748999393571","44748999196963","49696602423630","49696602620238","44748984484131","47990291497294","47990291530062","47196100165966","47196100198734","46744639308110","47196100297038","51042429632846","52757478113614","52757478146382","46710049112398"]},caroptionsAmersfoort:{products:[],variants:["44748984484131","44749454311715"]},caroptionsBrugge:{products:[],variants:["49720836325710","44748999393571","44748999196963","49696602423630","49696602620238","44748984484131","47990291497294","47990291530062","47196100165966","47196100198734","46744639308110","47196100297038","51042429632846","52757478113614","52757478146382","46710049112398"]},caroptionsVenlo:{products:[],variants:["49720836325710","44748999393571","44748999196963","49696602423630","49696602620238","44748984484131","47990291497294","47990291530062","47196100165966","47196100198734","46744639308110","47196100297038","51042429632846","52757478113614","52757478146382","46710049112398"]},caroptionsTwente:{products:["9898366304590","9888857194830","9857903886670","9021283107150","9753006145870","8598902964558","8400368009550","8396431327566","8199566491939","9705406103886","9845580988750","8396250677582","8232825323811","10413872709966"],variants:["49344668205390","49348863361358","49344668238158","49349074944334","46721770193230","52757473165646","52757473198414","46933198799182","47196100165966","52757473231182","46933198930254","47196100198734","52757854093646","52757854093646","52757473296718","46744639308110","46755747070286","51030321398094","52757473329486","46933202993486","47196100297038","52757473362254","51042429632846","52757478113614","52757478146382","50010766278990","47990538076494","47990255386958","47990255419726","46706533892430","47990538109262","48018160288078","47990748709198","47990732554574","47990291497294","47990291530062","46706533990734","46706534023502","47183941271886","47991134355790","46706534416718","48018954846542","47528067203406","44465120444707","47197146448206","44465120641315","47197146513742","44465120837923","47197146546510","44465120936227","44465121034531","44465121067299","47090076680526","44465121132835","44465121329443","47197715759438","47197146743118","44465121526051","47197146775886","44465121624355","44465121755427","47090076909902","44465121853731","47090076942670","44465121919267","47197785948494","49720836325710"]},haag:{products:[],variants:[]}},state={apiKey:null,mapId:null,styles:null,modalEl:null,map:null,markers:new Map,markerEls:new Map,activeKey:null,visibleLocations:[]};function loadGoogle(apiKey){return new Promise((resolve,reject)=>{if(window.google&&google.maps&&google.maps.marker)return resolve();const s=document.createElement("script");s.src=`https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&libraries=marker&v=weekly&language=nl&region=NL`,s.async=!0,s.onerror=()=>reject(new Error("Failed to load Google Maps")),s.onload=()=>resolve(),document.head.appendChild(s)})}function getVariantIdFromUrl(){return new URLSearchParams(location.search).get("variant")}function shouldHideLocation(locationKey,selectorValue,productId,selectEl){const optExists=!!selectEl?.querySelector(`option[value="${escapeCSS(selectorValue)}"]`),productHidden=HIDDEN[locationKey]?.products?.includes(productId),variantHidden=HIDDEN[locationKey]?.variants?.includes(getVariantIdFromUrl());return!optExists||productHidden||variantHidden}function moveCardOnMarkerClick(key){const list=q(".c-loc__list"),card=q(`.c-loc-card[data-key="${key}"]`);if(!(!list||!card))if(qa(".c-loc-card").forEach(el=>el.classList.toggle("c-loc-card--active",el===card)),isMobile())list.firstElementChild!==card&&list.insertBefore(card,list.firstElementChild),list.scrollTop=0,wiggle(card);else{const target=card.offsetTop+card.offsetHeight/2-list.clientHeight/2,maxTop=list.scrollHeight-list.clientHeight,clamped=Math.max(0,Math.min(target,maxTop));list.scrollTo({top:clamped,behavior:"smooth"})}}function buildMarkerEl({key,active=!1}={}){const el=document.createElement("div");el.className=`c-loc-marker${active?" c-loc-marker--active":""}${key==="caroptionsBleiswijk"?" big":" small"}`;const src=key==="caroptionsBleiswijk"?"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/marker_big.png?v=1756334018":"https://cdn.shopify.com/s/files/1/0727/7477/9171/files/marker_small_dc5ee1cb-4392-48fc-8de0-2512f9d55694.png?v=1756334016";return el.innerHTML=`<img src="${src}" alt="marker" class="c-loc-marker__img">`,el}function renderList(locations){const productId=window.ShopifyAnalytics?.meta?.product?.id,list=q(".c-loc__list");list.innerHTML="";for(const loc of locations){const card=document.createElement("article");card.className="c-loc-card",card.dataset.key=loc.key,card.innerHTML=`
        <div class="c-loc-card__media"><img src="${loc.img}" alt="${loc.title}"></div>
        <div class="c-loc-card__body">
          <h3 class="c-loc-card__title">${loc.title}</h3>
          <div class="c-loc-card__subtitle">${loc.subtitle||""}</div>
          <div class="c-loc-card__addr">
              <?xml version="1.0" encoding="UTF-8"?>
                <svg width="16px" height="21px" viewBox="0 0 16 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <title>Combined Shape Copy 2</title>
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" fill-opacity="0.863882212">
                            <g id="Desktop-HD-Copy-13" transform="translate(-1207.000000, -670.000000)" fill="#FF4E00">
                                <g id="Group-10" transform="translate(1095.000000, 606.000000)">
                                    <path d="M119.640349,64 C123.859966,64 127.280699,67.4397354 127.280699,71.6833805 C127.280699,79.0071033 119.640349,84.7195913 119.640349,84.7195913 C119.640349,84.7195913 119.441589,84.5645727 119.108184,84.2748458 L118.892497,84.0850073 C116.96901,82.3710188 112,77.3908769 112,71.6833805 C112,67.4397354 115.420732,64 119.640349,64 Z M119.640349,68.4521436 C117.858697,68.4521436 116.414424,69.9087175 116.414424,71.7057221 C116.414424,73.5025488 117.858697,74.9591227 119.640349,74.9591227 C121.422002,74.9591227 122.866275,73.5025488 122.866275,71.7057221 C122.866275,69.9087175 121.422002,68.4521436 119.640349,68.4521436 Z" id="Combined-Shape-Copy-2"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                ${loc.address}
            </div>
            <div class="c-loc-card__disc" style="${!loc.discount||productId===9845580988750?"display:none;":""}">
                Discount: <strong>\u20AC50,-</strong>
            </div>
        </div>
        <div class="c-loc-card__cta">
          <button class="c-loc-card__btn" type="button">Select</button>
        </div>
        <div class="c-loc-card__ribbon" style="${!loc.discount||productId===9845580988750?"display:none;":""}">
            SALE
        </div>
      `,card.addEventListener("click",e=>{if(!(e.target instanceof HTMLElement&&e.target.closest(".c-loc-card__btn"))){if(isMobile()){const list2=q(".c-loc__list",state.modalEl);list2&&list2.dataset.scrollEnabled!=="1"&&setScrolled(!0)}focusLocation(loc.key,{source:"list"})}}),card.querySelector(".c-loc-card__btn").addEventListener("click",()=>selectLocation(loc)),list.appendChild(card)}applyDynamicScrollPosition()}function setActiveCard(key){qa(".c-loc-card").forEach(el=>el.classList.toggle("c-loc-card--active",el.dataset.key===key));const activeEl=q(`.c-loc-card[data-key="${key}"]`);activeEl&&activeEl.scrollIntoView({block:"center",inline:"nearest",behavior:"smooth"})}function showTooltipForMarker(key,loc){qa(".c-loc-tooltip").forEach(el=>el.remove());const markerEl=state.markerEls.get(key);if(!markerEl)return;const tooltip=document.createElement("div");tooltip.className="c-loc-tooltip",tooltip.innerHTML=`
      <div class="c-loc-tooltip__inner">
        <p>${loc.title}</p>
        <button class="c-loc-tooltip__btn">Select</button>
      </div>
    `,markerEl.appendChild(tooltip),tooltip.querySelector("button").addEventListener("click",()=>{selectLocation(loc)})}function clearSelection(){if(state.activeKey&&state.markerEls.get(state.activeKey)){state.markerEls.get(state.activeKey).classList.remove("c-loc-marker--active");const prevAdv=state.markers.get(state.activeKey);prevAdv?.element&&(prevAdv.element.removeAttribute("tabindex"),prevAdv.element.style.removeProperty("z-index"))}qa(".c-loc-tooltip").forEach(el=>el.remove()),qa(".c-loc-card").forEach(el=>el.classList.remove("c-loc-card--active")),state.activeKey=null}function focusLocation(key,{source="marker"}={}){if(!state.map)return;if(state.activeKey&&state.markerEls.get(state.activeKey)){state.markerEls.get(state.activeKey).classList.remove("c-loc-marker--active");const prevAdv=state.markers.get(state.activeKey);prevAdv&&(prevAdv.element?.removeAttribute("tabindex"),prevAdv.element?.style.removeProperty("z-index"))}qa(".c-loc-tooltip").forEach(el=>el.remove()),state.activeKey=key,isMobile()&&source==="marker"&&setScrolled(!1);const adv=state.markers.get(key),loc=state.visibleLocations.find(l=>l.key===key);adv&&(state.markerEls.get(key).classList.add("c-loc-marker--active"),adv.element&&(adv.element.setAttribute("tabindex","0"),adv.element.style.zIndex="9999"),state.map.panTo(adv.position),isMobile()&&source==="marker"?moveCardOnMarkerClick(key):setActiveCard(key),showTooltipForMarker(key,loc)),document.dispatchEvent(new CustomEvent("co:location-marker-click",{detail:{key,location:loc,source}}))}function selectLocation(loc){const selectEl=q(".location_selector select");selectEl&&(selectEl.value=loc.selectorValue,selectEl.dispatchEvent(new Event("change",{bubbles:!0})),setLocationPreview(loc),COMapPicker.close())}function buildModal(){const el=document.createElement("div");el.className="c-loc",el.innerHTML=`
    <div class="c-loc__backdrop" data-close></div>
    <div class="c-loc__dialog" role="dialog" aria-modal="true" aria-label="Choose your installation location">
      <div class="c-loc__grid">
        <div class="c-loc__sideHead c-loc__mobile">
            <button class="c-loc__close" type="button" data-close aria-label="Close"></button>
            <h2 class="c-loc__title">Choose your installation location</h2>
            <hr>
            <p class="c-loc__intro">
              A spacious workspace, coffee/tea and free wifi are included at all our installation locations.
            </p>
            <div class="c-loc__note">\u23F1 Appointment scheduled within 24 hours</div>
          </div>
      
        <!-- Linker kolom: de kaart -->
        <div class="c-loc__mapwrap">
          <div id="co-map" class="c-loc__map" aria-label="Map with locations"></div>
        </div>
        <!-- Rechter kolom: tekst + lijst -->
        <aside class="c-loc__side">
          <div class="c-loc__sideHead c-loc__desktop">
            <button class="c-loc__close" type="button" data-close aria-label="Close">
              <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1"
                   xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                   aria-hidden="true" focusable="false">
                <title>Combined Shape</title>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Desktop-HD-Copy-13" transform="translate(-1539.000000, -471.000000)" fill="#494949">
                    <g id="Group-4" transform="translate(1524.000000, 456.000000)">
                      <path id="Combined-Shape" d="M18.6949675,15.8249459 L22.999545,20.129545 L27.3050325,15.8249459 C28.0558547,15.0741237 29.2486254,15.0346067 30.0459685,15.706395 L30.1750541,15.8249459 C30.9675887,16.6174805 30.9675887,17.9024329 30.1750541,18.6949675 L30.1750541,18.6949675 L25.869545,22.999545 L30.1750541,27.3050325 C30.9675887,28.0975671 30.9675887,29.3825195 30.1750541,30.1750541 C29.3825195,30.9675887 28.0975671,30.9675887 27.3050325,30.1750541 L22.999545,25.869545 L18.6949675,30.1750541 C17.9441453,30.9258763 16.7513746,30.9653933 15.9540315,30.293605 L15.8249459,30.1750541 C15.0324113,29.3825195 15.0324113,28.0975671 15.8249459,27.3050325 L15.8249459,27.3050325 L20.129545,22.999545 L15.8249459,18.6949675 C15.0324113,17.9024329 15.0324113,16.6174805 15.8249459,15.8249459 C16.6174805,15.0324113 17.9024329,15.0324113 18.6949675,15.8249459 Z"></path>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
            <h2 class="c-loc__title">Choose location</h2>
            <p class="c-loc__intro">
              A spacious workspace, coffee/tea and free wifi are included at all our installation locations.
            </p>
            <div class="c-loc__note">\u23F1 Appointment scheduled within 24 hours</div>
          </div>
          <div class="c-loc__list" role="list"></div>
        </aside>
      </div>
    </div>
  `,document.body.appendChild(el),el.addEventListener("click",e=>{e.target.matches("[data-close]")&&COMapPicker.close()}),document.addEventListener("keydown",keyEscHandler),state.modalEl=el,bindMobileScrollBehavior()}function keyEscHandler(e){e.key==="Escape"&&COMapPicker.close()}function debounce(fn,wait=180){let t;return(...args)=>{clearTimeout(t),t=setTimeout(()=>fn.apply(null,args),wait)}}function bindMobileScrollBehavior(){const grid=q(".c-loc__grid",state.modalEl),list=q(".c-loc__list",state.modalEl);if(!grid||!list)return;setScrolled(!1);let touchStartY=0;list.addEventListener("click",()=>{isMobile()&&list.dataset.scrollEnabled!=="1"&&setScrolled(!0)}),list.addEventListener("touchstart",e=>{isMobile()&&(touchStartY=e.touches?.[0]?.clientY??0)},{passive:!0}),list.addEventListener("touchmove",e=>{if(!isMobile())return;(e.touches?.[0]?.clientY??0)-touchStartY<-8&&list.dataset.scrollEnabled!=="1"&&setScrolled(!0)},{passive:!0}),list.addEventListener("wheel",e=>{isMobile()&&e.deltaY>0&&list.dataset.scrollEnabled!=="1"&&setScrolled(!0)},{passive:!0})}async function initMap(locations){if(!(window.google&&google.maps&&google.maps.marker)&&(await loadGoogle(state.apiKey),!(window.google&&google.maps&&google.maps.marker))){console.warn("[COMapPicker] Google Maps (marker lib) not ready yet.");return}const mapDiv=q("#co-map",state.modalEl),opts={center:{lat:52.2,lng:5.3},zoom:7,disableDefaultUI:!0,gestureHandling:"greedy",mapId:state.mapId||void 0,styles:state.mapId?void 0:state.styles||void 0};state.map=new google.maps.Map(mapDiv,opts),state.map.addListener("click",()=>{clearSelection(),isMobile()&&setScrolled(!1)});function getMarkersCenter(locations2){let lat=0,lng=0;return locations2.forEach(loc=>{lat+=loc.lat,lng+=loc.lng}),{lat:lat/locations2.length,lng:lng/locations2.length}}function getResponsiveZoom(containerEl){const rect=containerEl.getBoundingClientRect();let zoom2=8;return rect.width<530&&(zoom2=7),rect.height<750&&(zoom2=7),zoom2}const center=getMarkersCenter(locations),zoom=getResponsiveZoom(mapDiv);state.map.setCenter(center),state.map.setZoom(zoom),state._onResize&&window.removeEventListener("resize",state._onResize),state._onResize=debounce(()=>{const center2=getMarkersCenter(state.visibleLocations),zoom2=getResponsiveZoom(mapDiv);state.map.setCenter(center2),state.map.setZoom(zoom2),applyDynamicScrollPosition()},200),window.addEventListener("resize",state._onResize),state.markers.clear(),state.markerEls.clear();for(const loc of locations){const markerEl=buildMarkerEl({key:loc.key,active:!1}),adv=new google.maps.marker.AdvancedMarkerElement({map:state.map,position:{lat:loc.lat,lng:loc.lng},content:markerEl,title:loc.title});adv.addListener("gmp-click",()=>focusLocation(loc.key,{source:"marker"})),adv.addListener("click",()=>focusLocation(loc.key,{source:"marker"})),state.markers.set(loc.key,adv),state.markerEls.set(loc.key,markerEl)}}function computeVisibleLocations(all=DEFAULT_LOCATIONS){const selectEl=q(".location_selector select"),productIdEl=q('input[name="product-id"]');if(!selectEl||!productIdEl||selectEl.options.length===0)return all;const productId=productIdEl.value;return all.filter(l=>!shouldHideLocation(l.key,l.selectorValue,productId,selectEl))}window.COMapPicker={configure({apiKey,mapId=null,styles=null}={}){state.apiKey=apiKey,state.mapId=mapId,state.styles=styles},async open(locations=DEFAULT_LOCATIONS){state.modalEl&&this.close(),buildModal(),lockBodyScroll(),state.visibleLocations=computeVisibleLocations(locations),renderList(state.visibleLocations),await initMap(state.visibleLocations),document.documentElement.classList.add("c-loc--open"),applyDynamicScrollPosition()},close(){state.modalEl&&(state.modalEl.remove(),state.modalEl=null,document.removeEventListener("keydown",keyEscHandler)),state.map=null,state.markers.clear(),state.markerEls.clear(),state._onResize&&(window.removeEventListener("resize",state._onResize),state._onResize=null),unlockBodyScroll(),document.documentElement.classList.remove("c-loc--open")}};const CSS_TEXT=`
html.c-loc--open { overflow: hidden; }

.c-loc {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: grid;
  place-items: center;
  font-family: inherit;
}
.c-loc__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, .65);
  backdrop-filter: blur(1px);
  -webkit-filter: blur(1px);
}

.c-loc__dialog {
  position: relative;
  width: min(1180px, 94vw);
  height: 830px;
  max-height: 92vh;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 30px 60px rgba(0,0,0,.45);
  overflow: hidden;
}

.c-loc__grid {
  display: grid;
  grid-template-columns: 1fr 520px;
  grid-auto-rows: 1fr; 
  height: 100%;
}

.c-loc__desktop { display: block; }
.c-loc__mobile { display: none; }

.c-loc__sideHead {
  position: relative;
  padding: 9px 18px 12px;
  background: #1d4ed8;
  color: #fff;
}
.c-loc__sideHead.c-loc__desktop {
  background: #fff;
}

.c-loc__title {
  margin: 0;
  font-size: 30px;  
  font-weight: 700;
  letter-spacing: -0.23px;
  color: #494949;
}
.c-loc__intro {
  margin: 8px 0 6px;
  opacity: .95;
  color: rgba(73,73,73,0.8);
  font-size: 16px;
  line-height: 20px;
  padding-right: 42px;     
}
.c-loc__note {
  font-weight: 700;
  display: inline-block;
  background: rgba(255,255,255,.15);
  padding: 0; 
  border-radius: 10px;
  font-size: 16px;      
  line-height: 24px;  
  color: #494949; 
}

.c-loc__back,
.c-loc__close {
  position: absolute;
  top: 12px;
  width: 46px;
  height: 46px;
  border: 0;
  border-radius: 999px;
  background: #D8D8D8;
  cursor: pointer;
}

.c-loc__close svg{
pointer-events:none;
}
.c-loc__close:hover {
background: #929292;
}
.c-loc__back { left: 12px; }
.c-loc__close { right: 12px; }

.c-loc__back::before {
  content: "\u2190";
  font-size: 18px;
}
.c-loc__close::before {
  content: none;
}
.c-loc__close svg {
  position: absolute;
  top: 15px;
  left: 15px;
  width: 16px;
  height: 16px;
  display: block;
}

.c-loc-card__ribbon {
    position: absolute;
    top: -7px;
    right: 12px;
    padding: 4px 7px;
    background-color: #FF4E00;
    border-radius: 100px;
    font-size: 11px;
    font-weight: 700;
    color: white;
}

.c-loc-card__disc {
    display: inline-block;
    padding: 5px 12px;
    margin: 8px 0 5px;
    background-color: #FF4E00;
    border-radius: 100px;
    font-size: 13px;
    color: white;
}

/* --------- Kaart links --------- */
.c-loc__mapwrap {
  position: relative;
  height: 100%;       /* exact zo hoog als dialog/grid */
  min-height: 0;
  background: #eef3ff;
}
.c-loc__map {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

/* --------- Rechter kolom (tekst + lijst) --------- */
.c-loc__side {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-left: 1px solid #e6ebf2;
  min-height: 0;
}

/* Alleen de lijst scrolt */
.c-loc__list {
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;
  padding: 10px;
  background-color: #F5F5F5; /* aangepast */
}

/* --------- Cards --------- */
.c-loc-card {
  display: grid;
  grid-template-columns: 87px 1fr auto; /* aangepast */
  gap: 12px;
  align-items: center;
  padding: 9px; /* aangepast */
  margin: 10px 12px; /* aangepast */
  border: none;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, .15); /* aangepast */
  cursor: pointer;
  min-height: 105px; /* toegevoegd */
  transform: scale(1);
  transition: transform 0.2s ease;  
}

@media not screen and (max-width: 767px) {
    .c-loc-card:hover {
        transform: scale(1.02);
    }
}

.c-loc-card.c-loc-card--active {
  border: 3px solid #f39b5b;
  padding: 6px; /* aangepast omdat basis padding kleiner is */
  box-shadow: 0 0 8px 6px rgba(243,155,91,.5);
}

.c-loc-card.c-loc-card--active:hover {
    transform: scale(1);
}

.c-loc-card__media {
  height: 87px; /* nieuw */
  width: 87px;  /* nieuw */
}

.c-loc-card__media img {
  height: 87px; /* aangepast */
  width: 87px;  /* aangepast */
  object-fit: cover;
  border-radius: 10px;
  display: block;
}

.c-loc-card__title {
  margin: 0 0 -2px 0; /* marge onder iets kleiner */
  color: #1d4ed8;
  font-weight: 800;
  font-size: 18px;       /* aangepast */
  letter-spacing: -0.14px; /* toegevoegd */
}

.c-loc-card__subtitle {
  color: #2563eb;
  opacity: .9;
  font-size: 12px; /* aangepast */
}

.c-loc-card__addr {
  color: #374151;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  margin-top: 2px;
  line-height: 16px;
}

.c-loc-card__btn {
  appearance: none;
  border: 0;
  background: #2563eb;
  color: #fff;
  padding: 11px 13px; /* aangepast */
  font-weight: 400;   /* aangepast */
  border-radius: 10px;
  cursor: pointer;
}
.c-loc-card__btn:hover { filter: brightness(.95); }

.c-loc-marker {
    position:relative;
    cursor: pointer;
    width: 59px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.c-loc-marker.big {
    width: 89px;
}

.c-loc-marker__dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #1d4ed8;
  border: 2px solid white;
  box-shadow: 0 2px 6px rgba(0,0,0,.25);
}
.c-loc-marker--active {
  z-index: 99;
}
.c-loc-marker--special svg {
  width: 24px;
  height: 24px;
  fill: #ef6c00;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,.3));
}

.c-loc-marker__img {
  display: block;
  width: 100%;
  max-width: 125px !important;
  height: auto;
  transition: transform 0.2s ease;
  transform-origin: bottom center;
  transform: translateY(9%) scale(1);
  min-height: 85px;
  min-width: 140px;
  pointer-events: none;
}

.c-loc-marker.big .c-loc-marker__img {
    max-width: 187px !important;
    transform: translateY(6%);
    min-height: 123px;
    min-width: 187px;
}

/* hover + focus effect */
.c-loc-marker:hover .c-loc-marker__img,
.c-loc-marker--active .c-loc-marker__img {
 filter: hue-rotate(187deg) saturate(7.5);
}

.c-loc-marker.big:hover .c-loc-marker__img,
 .c-loc-marker--active.big .c-loc-marker__img,{
   filter: hue-rotate(187deg) saturate(7.5);
}

.c-loc-marker--active .c-loc-marker__img {
    filter: hue-rotate(187deg) saturate(7.5);
}

.c-loc-tooltip {
  position: absolute;
  bottom: 100%; /* boven de marker */
  left: 50%;
  transform: translateX(-50%) translateY(-8px);
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 6px 18px rgba(0,0,0,.18);
  padding: 12px 14px 14px;
  min-width: 194px;
  text-align: center;
  z-index: 999;
  animation: fadeInTooltip .18s ease-out;
}

.c-loc-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 8px;
  border-style: solid;
  border-color: #fff transparent transparent transparent;
}

.c-loc-tooltip__title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937; /* donkergrijs */
  margin-bottom: 10px;
  line-height: 1.4;
}

.c-loc-tooltip__btn {
  display: inline-block;
  background: #2563eb;
  color: #fff;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: background .2s ease;
}
.c-loc-tooltip__btn:hover {
  background: #1d4ed8;
}

.c-loc-tooltip p {
    margin-bottom: 10px;
    font-size: 14px;
    color: #454545;
    font-weight: 600;
}

gmp-advanced-marker[tabindex="0"] {
    z-index: 9999;
}

@keyframes fadeInTooltip {
  from { opacity: 0; transform: translateX(-50%) translateY(-4px); }
  to   { opacity: 1; transform: translateX(-50%) translateY(-8px); }
}


/* ====================== Mobile (tot 767px) ====================== */
@media (max-width: 767px) {
  .c-loc__dialog {
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    border-radius: 0;
    max-height: none;
  }
  .c-loc__grid {
    grid-template-columns: 1fr;
    grid-auto-rows: auto auto 1fr;
    height: 100%;
  }
  .c-loc__mobile { display: block; }
  .c-loc__desktop { display: none; }
  .c-loc__mapwrap { height: 48vh; }
  .c-loc__side { border-left: 0; }
}

@media not screen and (min-width: 1000px) {
 .c-loc__grid {
     grid-template-columns: 1fr 400px;
 }   
}

@media screen and (min-width: 768px) and (max-width: 1000px) {
  .c-loc-card {
 grid-template-columns: 70px 1fr auto;
 }
 
 .c-loc-card__title {
     font-size: 17px;
 }
 
 .c-loc-card__media,
 .c-loc-card__media img {
     width: 70px;
     height: 70px;
 }
 
 .c-loc-card__media{
 position: relative;
    transform: translateY(24px);
 }
 
 .c-loc-card__addr {
     font-size: 13px;
 }
 
 .c-loc-card__body,
 .c-loc-card__cta {
     grid-column: 2;
 }
 
 .c-loc-card__btn {
     padding: 9px 33px;
 }
}

@media not screen and (min-width: 768px) {
    .c-loc__grid {
        grid-template-columns: 1fr;
    }
    
    .c-loc__close {
        height: 66px;
        left: 0;
        top: 0;
        width: 66px;
        border-radius: 0;
        background: none;
    }
    
    .c-loc__close:after {
        content: "";
        background-image: url('data:image/svg+xml,<%3Fxml version="1.0" encoding="UTF-8"%3F><svg width="25px" height="19px" viewBox="0 0 25 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Line</title><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="iPhone-13-Pro-Max-Copy-15" transform="translate(-18.000000, -71.000000)" fill="%23FFFFFF" fill-rule="nonzero"><path d="M28.3332051,71.2547587 C29.2967495,70.3926401 30.5799385,71.7680343 29.7507902,72.6628438 L29.6667949,72.7452413 L22.116,79.5 L41.3338797,79.5 C41.8467156,79.5 42.2693869,79.8860402 42.327152,80.3833789 L42.3338797,80.5 C42.3338797,81.0128358 41.9478395,81.4355072 41.4505009,81.4932723 L41.3338797,81.5 L22.117,81.5 L29.6667949,88.2547587 C30.0467199,88.5946916 30.105871,89.1595111 29.8230762,89.5681181 L29.7452413,89.6667949 C29.4053084,90.0467199 28.8404889,90.105871 28.4318819,89.8230762 L28.3332051,89.7452413 L18.872,81.28 L18.8362739,81.2518494 C18.7636176,81.186813 18.7014195,81.1116097 18.6509138,81.0294708 L18.604,80.945 L18.5658583,80.8569024 L18.5357089,80.7654775 L18.5141775,80.6715828 L18.5015384,80.5759363 C18.4799345,80.3191815 18.5561082,80.0513995 18.7534686,79.8338609 L18.8332051,79.7547587 L28.3332051,71.2547587 Z" id="Line"></path></g></g></svg>');
        width: 26px;
        height: 22px;
        display: block;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        position: absolute;
        left: 18px;
        top: 50%;
        transform: translateY(-50%);
    }
    
    .c-loc__title {
        font-size: 22px;
        display: flex;
        height: 66px;
        align-items: center;
        padding-left: 41px;
        color: white;
    }
    
    .c-loc__title + hr {
        max-width: 100%;
        opacity: 0.3;
        margin-top: 0;
    }
    
    .c-loc__intro {
        font-size: 14px;
        line-height: 17px;
        color: white;
        opacity: 0.79;
        margin: 0;
    }
    
    .c-loc__note {
        background: none;
        color: white;
        margin: 10px 0 0;
    }
    
    .c-loc__sideHead {
        padding: 0px 18px 12px;
        padding-bottom: 46px;
    }
    
    .c-loc__mapwrap {
        margin-top: -30px;
        border-radius: 30px 30px 0 0;
        overflow: hidden;
        box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
        height: calc(85vh - 200px);
        height: calc(85dvh - 200px);
    }
    
    .c-loc__side {
        position: relative;
        border-radius: 30px 30px 0 0;
        margin-top: -30px;
        overflow: hidden;
        box-shadow: 0 2px 35px rgba(0, 0, 0, 0.8);
    }
    
    .c-loc-card {
        margin: 10px 4px;
    }

    .c-loc__list {
        padding: 0 9px 10px;
        overflow: hidden;
        -webkit-overflow-scrolling: touch;
    }
    
    .c-loc__grid.c-loc__scrolled .c-loc__list {
        overflow-y: auto;
    }
    
    .c-loc {
        z-index: 1000000000000000001;
    }
    
    .c-loc__grid .c-loc__mapwrap {
        transition: height 0.5s ease, transform .35s ease;
        will-change: transform;
    }

    .c-loc__grid .c-loc__sideHead hr {
        transition: opacity 0.5s ease;
    }
    
    .c-loc__grid.c-loc__scrolled .c-loc__mapwrap {
        height: calc(75vh - 200px);
        height: calc(75dvh - 200px);
    }
    
    .c-loc__grid.c-loc__scrolled .c-loc__sideHead hr {
        opacity: 0;
    }
    
    .c-loc-marker__img {
        min-height: 65px;
        min-width: 110px;
    }
    
    .c-loc-marker.big .c-loc-marker__img {
        min-height: 73px;
        min-width: 127px;    
    }
    
    .c-loc-marker.big {
        width: 68px;
    }
    
    .c-loc-marker {
        width: 48px;
    }
    
    .c-loc-card__addr svg {
        display: none;
    }
    
    .c-loc-card__addr {
        font-size: 13px;
        letter-spacing: -0.35px;
        line-height: 15px;
    }
    
    .c-loc-card__media,
    .c-loc-card__media img {
        height: 77px;
        width: 77px;
    }
    
    .c-loc-card {
        min-height: 94px;
        padding: 9px 12px 9px 9px;
        grid-template-columns: 77px 1fr auto;
    }
    
    .c-loc-card.c-loc-card--active {
        padding: 6px 9px 6px 6px;
    }
    
    .c-loc-card__title {
        font-size: 17px;
    }
    
    html.c-loc--open,
    body.c-loc--open {
      overscroll-behavior: none;        /* geen 'pull-to-refresh' / achtergr. scroll */
      touch-action: manipulation;
    }
}

@media not screen and (min-width: 400px) {
    .c-loc-card__media,
    .c-loc-card__media img {
        height: 60px;
        width: 60px;
    }
    
    .c-loc-card {
        grid-template-columns: 60px 1fr auto;
    }
    
    .c-loc-card__title {
        font-size:16px;
    }
    
    .c-loc-card__btn {
        font-size: 14px;
        padding: 11px 10px;
    }
}

.c-loc-card--wiggle {
  animation: coCardWiggle 0.6s ease;
  will-change: transform;
}

@keyframes coCardWiggle {
  0%   { transform: translateX(0); }
  15%  { transform: translateX(-6px); }
  30%  { transform: translateX(6px); }
  45%  { transform: translateX(-4px); }
  60%  { transform: translateX(4px); }
  75%  { transform: translateX(-2px); }
  90%  { transform: translateX(2px); }
  100% { transform: translateX(0); }
}
`,style=document.createElement("style");style.textContent=CSS_TEXT,document.head.appendChild(style)})();function haveCriticalElements(root=document){const wrap=root.querySelector(".location_selector"),sel=root.querySelector(".location_selector select"),pidEl=root.querySelector('input[name="product-id"]');return{wrap,sel,pidEl,ok:!!(wrap&&sel&&pidEl)}}let _bound=!1;function bindTriggers(){const{wrap,sel}=haveCriticalElements();if(!wrap||!sel)return!1;if(wrap.dataset.coBound==="1")return!0;wrap.addEventListener("click",()=>{window.COMapPicker.open()});const checkbox=document.querySelector('input[data-type="switch"][name="Montage en Installatie"]');checkbox&&!checkbox.dataset.coBound&&(checkbox.addEventListener("change",()=>{checkbox.checked&&setTimeout(()=>window.COMapPicker.open(),300)}),checkbox.dataset.coBound="1");const firstOption=sel.querySelector("option");return firstOption&&(firstOption.textContent.trim().length===0||firstOption.textContent===sel.value)&&(firstOption.innerText="Choose a location"),wrap.dataset.coBound="1",!0}window.initNewMapPicker=function(){if(_bound)return!0;const{ok}=haveCriticalElements();if(!ok)return!1;try{window.COMapPicker.configure({apiKey:"AIzaSyDPlViLscqNcCOe7bDFDuSATckyrljULek",mapId:"fc06cb774d4b1c58fd600e81"})}catch{}const bound=bindTriggers();return _bound=bound,bound};
//# sourceMappingURL=/s/files/1/0727/7477/9171/t/4/assets/map-picker.js.map?v=1774431981
